import { Button, Checkbox, Col, Divider, Form, Input, Row } from "antd";
import { Link, useNavigate } from "react-router-dom";
import mailIcon from "../../assets/images/icon/mailIcon.svg";
import phoneIcon from "../../assets/images/icon/phoneIcon.svg";
import LOGO from "../../assets/images/ieat_logo_login.png";

import { useEffect, useState } from "react";
import packageJson from "../../../package.json";
import {
  PERMISSIONS,
  REMEMBER_ME,
  SUCCESS_CODE,
  USER_DATA,
} from "../../lib/const";
import { setTokenLocalStorage } from "../../lib/helper/auth";
import useAuth from "../../lib/hooks/useAuth";
import { authentication } from "../../services/authService";
import { getProfile } from "../../services/profileService";
import "./styles.css";

const EMAIL = "ieat.crm@gmail.com";
const PHONE_CONTACT = "Tel. 02 - 253 - 0561 ต่อ 1114, 1195, 1132";

const SignIn = () => {
  const [form] = Form.useForm();
  const [checked, setChecked] = useState(false);
  const navigate = useNavigate();
  const { setAuth } = useAuth();
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    const remember_me = localStorage.getItem(REMEMBER_ME);
    if (remember_me) {
      const values = JSON.parse(localStorage.getItem(REMEMBER_ME));
      form.setFieldsValue({
        username: values.username,
        password: values.password,
      });
      setChecked(values.remember);
    }
  }, [form]);

  const onFinish = async (values) => {
    if (checked) {
      localStorage.setItem(
        REMEMBER_ME,
        JSON.stringify({
          username: values.username,
          password: values.password,
          remember: checked,
        })
      );
    } else {
      localStorage.removeItem(REMEMBER_ME);
    }

    const request = {
      username: values.username,
      password: values.password,
    };

    const res = await authentication(request);
    if (res.data.code === SUCCESS_CODE) {
      const { objectValue } = res.data;
console.log("res.data===>");
console.log(res.data);


      setTokenLocalStorage(objectValue);

      const resp = await getProfile();

      if (resp.data.code === SUCCESS_CODE) {
        const { objectValue } = resp.data;
        console.log("login objectValue===>");
        console.log(objectValue);
        setAuth({
          user: objectValue,
          isLogin: true,
        });
        localStorage.setItem(USER_DATA, JSON.stringify(objectValue));
        localStorage.setItem(
          PERMISSIONS,
          JSON.stringify(objectValue.permissions)
        );
      }

      navigate("/", { replace: true });
    } else {
      if (res.data.code === "ERR-9999") {
        setErrMsg("เกิดข้อผิดพลาดภายในเซิร์ฟเวอร์");
      } else {
        setErrMsg("ชื่อผู้ใช้ระบบ หรือรหัสผ่านไม่ถูกต้อง โปรดลองอีกครั้ง!");
      }
    }
  };

  const onFinishFailed = (errorInfo) => {
    setErrMsg("กรุณาระบุข้อมูลให้ครบทุกฟิลด์");
  };

  const onRememberChange = (e) => {
    setChecked(e.target.checked);
  };

  return (
    <div className="page">
      <div className="sign_in">
        <div className="bg_signin" />
        <Row gutter={[24, 24]} style={{ height: "100%" }}>
          <Col
            span={10}
            align="center"
            style={{
              margin: "auto",
            }}
          >
            <div style={{ marginLeft: 100 }}>
              <Row gutter={[16]}>
                <Col span={24}>
                  <img
                    src={LOGO}
                    // width={120}
                    height={120}
                    alt={"I-EA-T LOGO"}
                    align="left"
                  />
                </Col>
                <Col span={24} align="left" style={{ marginBottom: 130 }}>
                  <h1 style={{ margin: "0 0 5px 0" }}>
                    การนิคมอุตสาหกรรมแห่งประเทศไทย
                  </h1>
                  <h3 style={{ fontWeight: 400, margin: "0 0 5px 0" }}>
                    Industrial Estate Authority of Thailand
                  </h3>
                </Col>
                <Col span={24} align="left" style={{ marginBottom: 0 }}>
                  <p style={{ fontSize: 18, margin: "0 0 5px 0" }}>
                    <span className={`txt_primary bold`}>สมัครสมาชิก</span>{" "}
                    หรือยัง?
                  </p>
                  <p style={{ fontSize: 15, margin: "0 0 5px 0" }}>
                    ถ้ายัง สามารถส่งข้อมูลการสมัครของคุณมาได้ที่
                  </p>
                  <p>
                    <a
                      href={`mailto:${EMAIL}`}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center"
                    >
                      <span style={{ marginTop: 5 }}>
                        <img
                          src={mailIcon}
                          width={16}
                          height={16}
                          alt="E-mail Icon"
                          style={{ marginRight: 10 }}
                        />
                      </span>{" "}
                      {EMAIL}
                    </a>
                  </p>
                  <div className="flex items-center">
                    <span>
                      <img
                        src={phoneIcon}
                        width={16}
                        height={16}
                        alt="Phone Icon"
                        style={{ marginRight: 10 }}
                      />
                    </span>
                    {PHONE_CONTACT}
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          <Col
            span={14}
            align="center"
            style={{
              margin: "auto",
            }}
          >
            <Form
              form={form}
              className="signin_form row"
              name="basic"
              layout="vertical"
              align="left"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              onValuesChange={() => setErrMsg(false)}
            >
              <p
                style={{
                  textAlign: "left",
                  fontSize: 18,
                  fontWeight: 600,
                  color: "#6442A4",
                  margin: 0,
                }}
              >
                ยินดีต้อนรับ
              </p>
              <p
                style={{
                  textAlign: "left",
                  fontSize: 27,
                  fontWeight: 600,
                  margin: 0,
                }}
              >
                เข้าสู่ระบบ
              </p>
              <p
                style={{
                  textAlign: "left",
                  fontSize: 14,
                  fontWeight: 500,
                  margin: 0,
                }}
              >
                เข้าสู่ระบบของท่านด้านล่างได้เลย
              </p>

              <Divider dashed />

              {errMsg && (
                <p
                  style={{
                    padding: "10px 0 20px",
                    color: "#F04438",
                    textAlign: "center",
                  }}
                >
                  {errMsg}
                </p>
              )}

              <Form.Item
                label="ชื่อผู้ใช้ระบบ"
                name="username"
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
                style={{ marginBottom: 20 }}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="รหัสผ่าน"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
                style={{ marginBottom: 10 }}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item name="remember" style={{ marginBottom: 20 }}>
                <div className="flex justify-between items-center">
                  <Checkbox checked={checked} onChange={onRememberChange}>
                    จำฉัน
                  </Checkbox>
                  <Link to="/forgot-password">ลืมรหัสผ่าน?</Link>
                </div>
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                >
                  ยืนยัน
                </Button>
              </Form.Item>

              <Row style={{ marginTop: 25 }}>
                <Col span={24} align="center">
                  <span>©</span>{" "}
                  <span style={{ color: "#A4A2A2" }}>
                    2023 All Right Reserved
                  </span>
                  <p style={{ color: "#A4A2A2", fontSize: 12 }}>
                    Website Version {packageJson.version}
                  </p>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SignIn;
